import format from 'date-fns/format'
import * as locale from 'date-fns/locale'
import { LocaleCode } from '../types/common'
import { WeekStartsOn } from '../types/dates'

export function localeFormat(
  date: Date,
  formatString: string,
  localeCode: LocaleCode,
  weekStartsOn: WeekStartsOn = 1
) {
  return format(date, formatString, {
    locale: locale[localeCode],
    weekStartsOn,
  })
}
